import { useState, useEffect } from 'react'
import { withoutActWarning } from '../without-act-warning'

export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value)

  // timeout integration
  useEffect(() => {
    const handler = setTimeout(() => {
      // Timer expiration is the React mutation boundary. Wrap the setter, not
      // the timer wait: act cannot make elapsed time part of a React update.
      withoutActWarning(() => {
        setDebouncedValue(value)
      })
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}
